import React from "react";
import useScrollReveal from "../../hooks/useScrollReveal";

/**
 * <Reveal> — wraps children in a div that animates in on scroll.
 *
 * Props:
 *   - as: element tag (default 'div')
 *   - variant: 'fade' | 'up' | 'up-lg' | 'scale'  (default 'up')
 *   - delay: ms delay before animation starts (default 0)
 *   - className: extra classes on the wrapper
 *   - threshold: intersection threshold (default 0.15)
 *
 * The actual animation is defined in landing.css via [data-reveal] /
 * [data-revealed] + [data-variant] selectors. Keeps everything declarative
 * and dep-free.
 */
export default function Reveal({
  as: Tag = "div",
  variant = "up",
  delay = 0,
  className = "",
  threshold = 0.15,
  children,
  ...rest
}) {
  const [ref, revealed] = useScrollReveal({ threshold });

  const style = delay ? { transitionDelay: `${delay}ms` } : undefined;

  return (
    <Tag
      ref={ref}
      className={className}
      data-reveal=""
      data-variant={variant}
      data-revealed={revealed ? "true" : "false"}
      style={style}
      {...rest}
    >
      {children}
    </Tag>
  );
}
